import { render, staticRenderFns } from "./project-events.vue?vue&type=template&id=4cfaa3a4&"
import script from "./project-events.vue?vue&type=script&lang=js&"
export * from "./project-events.vue?vue&type=script&lang=js&"
import style0 from "./project-events.vue?vue&type=style&index=0&id=4cfaa3a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports